import { mergeProps } from '@/utils/merge';
import { StandaloneCoverBox } from 'base/components/CoverBox';

export const SvenskdamStandaloneCoverBox: typeof StandaloneCoverBox = (props) => {
  return <StandaloneCoverBox {...mergeProps({ options: { className: 'hide-in-mobile-app' } }, props)} />;
};
